export default {
  PROVIDER: 'ROLE_OWNER',
  CUSTOMER: 'ROLE_CUSTOMER',
};
